export const navigation = [
  {
    text: "Início",
    path: "/home",
    icon: "home",
  },
  {
    text: "Cadastros",
    icon: "folder",
    items: [
      {
        text: "Empresas",
        path: "/companies",
        icon: "group",
      },
      {
        text: "Contas ElosGate",
        path: "/provider-accounts",
        icon: "card",
      }
    ],
  },
];
